
define('tmpl!core/templates/webidl/iterable.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlIterable\'>{{extAttr obj indent true\n}}{{idn indent}}iterable&lt;<span class=\'idlIterableKeyType\'>{{datatype obj.key}}</span>{{#if obj.value}},<span class=\'idlIterableValueType\'>{{datatype obj.value}}</span>{{/if}}&gt;;</span>\n');});

